import styles from './CoffeeDetailsTable.module.scss'
import { CoffeeDetailsTableRow } from './CoffeeDetailsTableRow'

import type { Metafield } from 'src/data/graphql-generated'

interface CoffeeDetailsTableProps {
  details: Metafield[]
  withoutModals?: boolean
}

export const CoffeeDetailsTable = ({ details, withoutModals = false }: CoffeeDetailsTableProps) => (
  <div className={styles.table}>
    {Boolean(details.length) &&
      details.map((detail) => {
        if (!detail) return null

        const { key, value } = detail

        return (
          <CoffeeDetailsTableRow
            key={`coffee-property-${key}`}
            metaKey={key}
            value={value}
            withoutModals={withoutModals}
          />
        )
      })}
  </div>
)
